<div class="text-grey">
  <div class="modal-header">
    <h4 class="modal-title synchpc-primary" id="modal-title">Resize Node</h4>
    <i style="z-index: 1" class="bi bi-x-lg text-danger" color="warn" (click)="onClose()" title="Close"></i>
  </div>

  <div class="modal-body">
    <form spellcheck="false" autocomplete="off" [formGroup]="resizeNodeForm" (ngSubmit)="onSubmit(resizeNodeForm)">

      <mat-form-field style="width: 100%">
        <mat-label>Node Size</mat-label>
        <mat-select formControlName="nodeSize">
          <mat-option *ngFor="let config of nodeConfigNames" value="{{config?.instanceCode}}" (click)="hpcConfigChanged(config?.hpcConfigId)">{{config?.instanceCode}} ({{ config?.description }})</mat-option>
        </mat-select>
      </mat-form-field>

      <div style="font-size: 12px;">
        <mat-hint align="start">Current : {{ currentHpcConfig?.description }}</mat-hint>
      </div>
      <div style="font-size: 12px;">
        <mat-hint align="start">Selected : {{ selectedHpcConfig?.description }}</mat-hint>
      </div>

      <div style="width: 100%; text-align: center; margin-top: 10%">
        <label for="">{{ noteMessage }}</label>
      </div>
    </form>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="onClose()">Close</button>
    <button type="button" class="btn btn-primary"
            [disabled]="!resizeNodeForm.valid || isFormSubmitted == true"
            (click)="onSubmit(resizeNodeForm)">
      Submit
    </button>
  </div>
</div>
<ngx-spinner bdColor="rgba(0,0,0,0)"
             size="default"
             zIndex="1"
             color="var(--s-primary-color)"
             type="ball-spin"
             [fullScreen]="false"
             name="addNode"><p class="pleaseWait text-grey">Please wait ...</p></ngx-spinner>
